import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useBreakpoint from 'hooks/useBreakpoint';
import { getDynamicImage } from 'helpers/ImageHelper';
import { isMobileBreakpoint } from 'helpers/BreakpointHelper';
import style from './Logo.module.scss';

const Logo = ({ alt, img, centeredImg, theme, title, context, unoptimized, isSeries }) => {
  const breakpoint = useBreakpoint();
  if (!img) return <div className={classNames(style.logoAlt, theme.logoAlt)}>{title}</div>;
  const image = getDynamicImage({
    breakpoint,
    url: isSeries && isMobileBreakpoint(breakpoint) ? centeredImg : img,
    context,
    unoptimized,
  });
  return <img className={classNames(style.logo, theme.logo)} src={image} alt={alt} />;
};

Logo.propTypes = {
  alt: PropTypes.string,
  context: PropTypes.string,
  img: PropTypes.string,
  isSeries: PropTypes.bool,
  centeredImg: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  title: PropTypes.string,
  unoptimized: PropTypes.bool,
};

export default Logo;
